import type { DebugSessionSearch } from "~/features/gameSession/debugSessionGenerator/debugSessionGeneratorTypes.ts";

const toNumber = (value: unknown): number | undefined => (typeof value === "number" ? value : undefined);
const toString = (value: unknown): string | undefined => (typeof value === "string" ? value : undefined);
const toBoolean = (value: unknown): boolean | undefined => (typeof value === "boolean" ? value : undefined);

/**
 * Parses the search params of the session settings.
 *
 * Rule: this file imports types only. The route configs import it outside the code-split component chunk, so any
 * other import ships in the main bundle.
 */
export const parseDebugSessionSearch = (search: Record<string, unknown>): DebugSessionSearch => ({
    games: toNumber(search.games),
    last: toString(search.last),
    zwennies: toNumber(search.zwennies),
    gameZwennies: toNumber(search.gameZwennies),
    rounds: toNumber(search.rounds),
    halvings: toNumber(search.halvings),
    roundHalvings: toNumber(search.roundHalvings),
    inLastRound: toBoolean(search.inLastRound),
    seed: toNumber(search.seed),
});
